<template>
    <section>
        <div class="spacing-large space-between">
            <div>

                <h2>3X Non-Standalone</h2>
                <p>Most CSPs start their 5G journey by choosing the Non-Standalone (NSA) 3X deployment option. This enables the existing LTE network to continue as the primary control network, with 5G base stations added to support extreme high-speed mobile data.</p>

            </div>
            <div>

                <infobutton>
                    The advantage of this solution is its fast time-to-market because it uses the existing Evolved Packet Core (EPC) with IMS handling the voice services.
                </infobutton>

                <div class="info-wrapper">
                    <infobutton :type="'disadvantage'">
                        The disadvantage of this solution is that the user’s mobile device must support dual radio connectivity, which can significantly reduce battery life.
                    </infobutton>
                </div>

            </div>
        </div>
        <div class="spacing-small center gray">

            <img src="~@/assets/images/chapter-3/architectural-evolution-3.png" alt="">

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    .info-wrapper {
        margin: 20px 0 0;
    }

</style>